<!--
    描述：项目管理-- 劳务通项目-- 查看详情页
    时间：2022-07-27
    Created by 李家宝
-->
<template>
  <div class="xunjiang-project-msg-main">
    <div class="juyihead">
      <el-tabs v-model="auditType" @tab-click="tabChange(auditType)">
        <el-tab-pane label="招募基本信息" name="1">
          <pro-baseinfo :rowData="rowData"></pro-baseinfo>
        </el-tab-pane>
        <el-tab-pane label="投递名片人" name="2">
          <deliverCard :rowData="rowData"></deliverCard>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import proBaseinfo from './pro-baseinfo';
import deliverCard from '../../components/deliver-card';

export default {
  components: {
    proBaseinfo,
    deliverCard
  },
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    audit: {
      type: String,
      default: ''
    }
  },
  filters: {
    dateFilter(time) {
      return bmTooljs.dateformat(new Date(time), 'yyyy-MM-dd');
    }
  },
  data() {
    return {
      auditType: '1' //tab项当前值
    };
  },
  created() {
    if (!this.rowData.id) {
      this.$router.push({
        name: 'xunjiang-project-list'
      });
      return;
    }
  },
  methods: {
    // tab切换
    tabChange(val) {
      this.currentPage = 1;
      this.pageSize = 10;
      this.auditState = val;
      // this.getTabNum()
      // this.getData()
    }
  }
};
</script>
<style scoped lang="less">
.xunjiang-project-msg-main {
  // height: 100%;
  .juyihead {
    padding: 15px 15px;
    background: #fff;

    /deep/ .el-tabs__item {
      width: 140px;
    }
  }
}
</style>
